export enum FetchChargerResponseEnum {
  UNAUTHORIZED = 'Unauthorized',
}
